import { useTranslation } from "~/i18n"
import Box from "~/components/UI/Box"
import Text from "~/components/UI/Text"


const Item: React.FC<{ name: string, content: string }> = ({ name, content }) => {
  return (
    <Box height='auto' margin='16px 0'>
      <Text bold style={{ marginBottom: 4 }}>
        {name}
      </Text>
      <Text opacity={0.7}>
        {content}
      </Text>
    </Box>
  )
}

const Branches = () => {
  const [t] = useTranslation()
  return (
    <>
      <Text bold style={{lineHeight: '40px', textTransform: 'capitalize'}}>
        {t('Các chi nhánh')}
      </Text>
      <Item
        name='Singapore HQ'
        content='68 Circular Road, #02-01, Singapore'
      />
      <Item
        name={t('Việt Nam')}
        content={t('Lầu 11, Robot Tower, 308 Điện Biên Phủ, Phường 4, Quận 3, TP. Hồ Chí Minh')}
      />
    </>
  )
}

export default Branches
